export const formTemplatesEndpoints = {
  getFormTemplates: { method: 'get', path: '/' },
  getFormTemplateById: { method: 'get', path: '/{id}' },
  getWorkflowsUsingFormTemplate: { method: 'get', path: '/{id}/workflows' },
  createFormTemplate: { method: 'post', path: '/' },
  updateFormTemplate: { method: 'post', path: '/{id}/update' },
  checkUpdateImpact: { method: 'post', path: '/{id}/update/check-impact' },
  uploadForm: { method: 'post', path: '/upload' },
  downloadFormTemplate: { method: 'post', path: '/download' },
  updateRequestsToLatestForm: { method: 'post', path: '/update-requests-to-latest-form' },
  getFormContextData: { method: 'post', path: '/get-form-context-data' },
  getFormContextDataV2: { method: 'post', path: '/get-form-context-data-v2' },
  getQuestionInsights: { method: 'get', path: '/{id}/insights/questions/{questionName}' },
  dismissQuestionInsight: { method: 'post', path: '/{id}/insights/{insightId}/dismiss' },
  questionInsightFeedback: { method: 'post', path: '/{id}/insights/{insightId}/feedback' },
  getQuestionInsightsByQuestionName: { method: 'get', path: '/{id}/insights/questions' },
  getQuestionInsightsByFormTemplateId: { method: 'get', path: '/insights/questions' },
} as const
